import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "čtvrtek 25. 9. –  neděle 28. 9. 2025"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Plavba kaňonem zaříznutým hluboko do skal, peřejnatá řeka, stromy nádherně obarvené podzimem, chladná rána, ale přes den teplo a slunce, to je babí léto na Dunajci v Pieninském národním parku. Když k tomu přidáte skvělou partu vodáků a večerní posezení u pivka a kytar, je to dokonalý vodácký víkend. Letos obohatíme naše vodácké toulky o řeku Poprad. Po loňském debaklu, kdy na horním toku nebyla voda, jsme pro nás vybrali až závěr řeky před soutokem do Dunajce, klidnou WW I. bez jezů, tekoucí krásnou přírodou. Tohle zmákneme hned ve čtvrtek. Jako rozcvičku. V pátek a sobotu si tradičně dáme horní a dolní část Dunajce. V neděli v klidu sbalíme bágly a po snídani odjedeme na termální koupaliště Goracy potok a pak domů. Takový je plán. Samozřejmě že se může vlivem počasí, stavu vody v řece či jiných okolností změnit. Doufejme, že ne moc! "),
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Program"),
    /*#__PURE__*/_createElementVNode("li", null, "čtvrtek 25.9.  odjezd"),
    /*#__PURE__*/_createElementVNode("li", null, " pátek 26.9.  sjezd řeky, úsek Kroscienko – Zabresz,16 km kdo bude chtít může ráno vyrazit na pěší turistiku "),
    /*#__PURE__*/_createElementVNode("li", null, " sobota 27.9. sjezd řeky, úsek Sromovce – Kroscienko,17 km, kdo bude chtít může ráno vyrazit na pěší turistiku "),
    /*#__PURE__*/_createElementVNode("li", null, " neděle 28.9. snídaně, balení bagáže, návštěva termálního koupaliště Gorocy Potok , odjezd domů "),
    /*#__PURE__*/_createElementVNode("li", null, " snídaně v 8 hod, pátek, sobota, neděle, oběd, v balíčku cestou – pátek, sobota, neděle "),
    /*#__PURE__*/_createElementVNode("li", null, "večeře - čtvrtek, pátek, sobota")
  ]),
  /*#__PURE__*/_createElementVNode("b", null, "Ubytováni"),
  /*#__PURE__*/_createTextVNode(": v apartmánech pro 2 – 6 osob vybavených WC a sprchou Řeku jedeme na lodích pro 2 os (Baraka) a pro 6 os (Coloredo, Robfin). Napište nám do přihlášky (na horní liště-objednávky) na jakém typu chcete jet. Řeky Poprad a Dunajec, ač peřejnaté, mají malou obtížnost, WW II. I tam se ale dá „udělat“ a tak těm kdo si moc nevěří nebo chtějí jet spolu s kamarády, doporučujeme „šestku“.Určitě si vemte neoprén. Bude sice pěkné počasí babího léta, ale znáte to, čert nikdy nespí. Těm co neopren nemají jej půjčíme (cena – neopren 100.-Kč/den, boty 30.-Kč /den). Do poznámky v objednávce napište velikost neoprenu. Máme M až XXXL, popř. velikost bot. Neopreny budete platit až při odjezdu, vezměte si drobné. Prosíme, hlaste se včas. Ať nejste na nás zase zlí, když nevyjde místo. Do objednávky napište nejen kolik vás pojede, ale také jména, adresy a data narození všech přihlášených. Na recepci musíme odevzdat seznam ubytovaných pro případnou kontrolu cizinecké policie (na Ukrajinu to není daleko). Díky za pochopení. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Odjezd:"),
  /*#__PURE__*/_createTextVNode(" čtvrtek 25.9.2025 z nového autobusového nádraží Frýdek "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Odjezd: čtvrtek 25.9.2025 z nového autobusového nádraží Frýdek sraz 13.30 hod, odjezd 14.00 !!! "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("b", null, "Návrat:"),
  /*#__PURE__*/_createTextVNode(" neděle 28.9.2025")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "center" }, " Cena: 5 100.-Kč ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createTextVNode(" V ceně: "),
    /*#__PURE__*/_createElementVNode("li", null, "autobus po celou dobu zájezdu"),
    /*#__PURE__*/_createElementVNode("li", null, "pátek, sobota, plná penze, čtvrtek večeře, neděle snídaně"),
    /*#__PURE__*/_createElementVNode("li", null, "lodě, pádla, vesty + technické zázemí"),
    /*#__PURE__*/_createElementVNode("li", null, "country kapela – kytary, foukací harmonika, perkusy"),
    /*#__PURE__*/_createTextVNode(" V ceně není: "),
    /*#__PURE__*/_createElementVNode("li", null, " není: vstupné na termál a pojištění. Doporučujeme uzavřít pojištění na cestu a pobyt, rafting a škody způsobené jiné osobě ")
  ]),
  /*#__PURE__*/_createTextVNode(" Pivo budeme prodávat za nákupní cenu, tj 40.-Kč. Ovšem do září je daleko, doufejme že nezdraží. Berte si sklo. Kdo nemá, budeme mít kelímky. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" SK varuje před požíváním alkoholu před a při jízdě v lodích. Ohrožujete tím nejen sebe ale i ostatní!")
], -1)

import CommonPage from "@/components/CommonPage.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Dunajec',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonPage, { title: "ZLATÝ DUNAJEC 2024" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7
    ]),
    _: 1
  }))
}
}

})